import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import Edit from './Edit';
import createSagaMiddleware from 'redux-saga';
import createRavenMiddleware from 'raven/middleware';
import { appendLoggerMiddlewareInDev } from 'utils/redux';
import rootReducer from './reducers';
import rootSaga from './sagas';
import { getTargets } from './reducers/diffusion';
import $ from 'jquery';
import { post } from 'utils/fetch';
import { error, storeSuccess } from 'plugins/toastr';
import { hideFormLoader } from 'plugins/loader';
import publish from './publish';
import postpone from './postpone';

export const renderEdit = id => {
  const sagaMiddleware = createSagaMiddleware();
  const ravenMiddleware = createRavenMiddleware();

  const middleware = [sagaMiddleware, ravenMiddleware];

  appendLoggerMiddlewareInDev(middleware);

  const store = createStore(rootReducer, applyMiddleware(...middleware));
  sagaMiddleware.run(rootSaga);

  // Rendering React UI
  ReactDOM.render(
    <Provider store={store}>
      <Edit />
    </Provider>,
    document.getElementById('root')
  );

  const $form = $('form');
  $form.on('submit', evt => {
    evt.preventDefault();

    const $form = $(evt.currentTarget);

    // Serializing form data
    const data = new FormData($form[0]);

    // Appending redux state
    const state = store.getState();

    const targets = getTargets(state).map(e => ({
      role: e.role,
      tags: e.tags,
    }));
    data.append('targets', JSON.stringify(targets));

    return handleFormSubmit($form, data, () => {
      // Storing flash in session for toast
      storeSuccess('Campagne de push mise à jour avec succès');

      // Moving to list page
      window.location.replace('/campaign');
    });
  });
};

function handleFormSubmit($form, data, successCallback) {
  const handleFormErrors = errors => {
    // Clearing existing errors
    $form.find('.field').removeClass('error');
    $form.removeClass('error');
    $form.find(`.error.message`).html('');

    const formError = errors[0];
    if (formError && formError.key) {
      $form
        .find(`input[name="${formError.key}"]`)
        .closest('.field')
        .addClass('error');

      $form.addClass('error');
      $form.find(`.error.message`).append(formError.messages[0]);
    }
  };

  const $submitButton = $(document.activeElement);

  const postForm = ({ push, postpone }) => {
    const url = $submitButton.attr('formaction') || $form.attr('action');

    // Append push to data
    data.append('push', push);
    data.append('postpone', postpone);

    return post(url, data).then(
      res => {
        hideFormLoader($form);
        successCallback(res);
      },
      err => {
        hideFormLoader($form);

        console.log('Error attempting to save campaign', err);
        if (err.res.status === 400) {
          err.res.json().then(json => handleFormErrors(json));
        } else {
          error(`Une erreur est survenue pendant la sauvegarde de la campagne`);
        }
      }
    );
  };

  // Displaying push settings modal if needed
  if ($submitButton.hasClass('publish')) {
    publish(push => postForm({ push }));
  } else if ($submitButton.hasClass('postpone')) {
    postpone(postpone => postForm({ postpone }));
  } else {
    postForm({});
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/modules/campaign/form.js